import { render } from "./index.vue?vue&type=template&id=47dbd91a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=47dbd91a&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=47dbd91a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47dbd91a"]])

export default __exports__